export default __webpack_public_path__ + "static/media/hypothalamus_mask.38fa66f3.png";